import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'

export const getCrmApiOptions = (account, endpoint, returnType = 'json', useCache = true) => {
  const options = {
    url: getUrl(siteNames.API_CRM, endpoint),
    returnType,
    useCache
  }

  if (account) {
    options.headers = {
      'X-CRM-AccountId': account.id,
      'X-CRM-PartnerId': account.partnerId
    }
  }

  return options
}
